<template>
  <div class="vote-buttons">
    <button @click="vote('upvote')" :class="{ active: userVote == 'upvote' }">
      <i class="fas fa-chevron-up"></i>
    </button>
    <span>{{ score }}</span>
    <button @click="vote('downvote')" :class="{ active: userVote == 'downvote' }">
      <i class="fas fa-chevron-down"></i>
    </button>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    initialScore: {
      type: Number,
      default: 0
    },
    initialUserVote: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      score: this.initialScore,
      userVote: this.initialUserVote
    }
  },
  methods: {
    async vote(voteType) {
      try {
        const response = await axios.post(`/vote/${this.type}/${this.id}`, {
          vote_type: voteType
        });
        if (response.data.success) {
          this.updateVote(voteType, response.data);
        }
      } catch (error) {
        console.error('Error voting:', error);
      }
    },
    updateVote(voteType, data) {
      this.score = data.score;
      if (this.userVote === voteType) {
        // Undo vote
        this.userVote = null;
      } else {
        // New vote or change vote
        this.userVote = voteType;
      }
    }
  }
}
</script>

<style scoped>
.vote-buttons {
  display: flex;
  align-items: center;
  font-size: 75%;
}
.vote-buttons button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2em;
  padding: 0 5px;
}
.vote-buttons button.active fas {
  background-color: #007bff;
}
</style>